var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGalleryRoundGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224 -500) translate(8 488) translate(216.5 12) translate(.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.01,
    cy: 17.01,
    r: 17.01,
    fill: "#08A985"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.91 9.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.289 12.364L11.44 4.588c-.147-.297-.433-.498-.759-.532-.325-.038-.647.101-.852.359L6.533 8.579 4.38 7.129c-.22-.146-.49-.198-.744-.14-.257.059-.48.221-.614.449l-2.886 4.86c-.179.3-.182.673-.012.98.17.304.49.492.837.492h13.466c.334 0 .642-.175.818-.462.176-.286.19-.644.043-.944z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.075,
    cy: 2.025,
    r: 2.025
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGalleryRoundGreen);
export default __webpack_public_path__ + "static/media/icon_gallery_round_green.359de0ff81d1a21f98c460154efee1ef.svg";
export { ForwardRef as ReactComponent };